import advanceTransformer from '@/transformers/purchase/advanceByPurchase'
import Vue from 'vue'

/**
 * @author José Luis R. <jose.ruiz@jbge.com.mx>
 *
 * Fetches all advances
 *
 * @param  purchase Purchase's id
 * @return {Array} Advance's info
 */

const fetchAdvancesByPurchase = purchase =>
  Vue.$http.get(`purchase/order/${purchase}/advance_request/list/`)
    .then(res => advanceTransformer.fetch(res.data))
    .catch((err) => {
      throw err
    })

export default fetchAdvancesByPurchase


// WEBPACK FOOTER //
// ./src/services/purchase/purchaseOrder/fetchAdvancesByPurchase.js